/**
 * @fileoverview GET handler for the "/apps/catalogs/:catalog_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsCatalogsCatalogId } from "./constants";
import type { AppsCatalogsCatalogIdGetResult } from "./types";
import { isAppsCatalogsCatalogIdGetResult } from "./validators";

export const getAppsCatalogsCatalogId = reactQueryFetcherAdapter(
  appsCatalogsCatalogId,
  (signal: AbortSignal, catalogId: string, appGroupId: string): Promise<AppsCatalogsCatalogIdGetResult> => {
    return fetch(`/apps/catalogs/${catalogId}`, "GET", { app_group_id: appGroupId }, { signal });
  },
  isAppsCatalogsCatalogIdGetResult
);
